import { Icon } from '@/shared/ui';

export const NoDataNew = ({
    titleBlue,
    titleBlack,
    description,
    buttonText,
    onButtonClick,
    type,
}: {
    titleBlue?: string;
    titleBlack?: string;
    description?: string;
    button?: boolean;
    buttonText?: string;
    onButtonClick?: () => void;
    type?: string;
}) => {
    return (
        <div
            className="search-no-result ttukttak_search-no-result"
            style={{ height: 'auto', textAlign: 'center' }}
        >
            {titleBlue && (
                <p className="desc-01 cont-mt3">
                    <span className="point">{titleBlue}</span>
                    {titleBlack && (
                        <>
                            <br />
                            {titleBlack}
                        </>
                    )}
                </p>
            )}
            {description && <p className="desc-03 con-mt1">{description}</p>}
            {type === 'keyword' && (
                <p className="desc-03 con-mt1">
                    다른 검색어로 입력하거나 발행 용도, 진행 상태 등을
                    <br />
                    다시 선택하여 검색해 보세요!
                </p>
            )}
            {buttonText && (
                <button
                    className="btn btn-default xlg blue con-mt2"
                    onClick={onButtonClick && onButtonClick}
                >
                    {buttonText} <Icon icon="gt" />
                </button>
            )}
        </div>
    );
};
<div
    className="search-no-result ttukttak_search-no-result"
    style={{ height: 'auto', textAlign: 'center' }}
>
    <p className="desc-01 con-mt3">
        <span className="point">#검색어#, #검색어#, #선택한 검색 필터</span>
        <br />
        검색 결과가 없습니다.
    </p>
    <p className="desc-03 con-mt1">
        다른 검색어로 입력하거나 발행 용도, 진행 상태 등을
        <br />
        다시 선택하여 검색해 보세요!
    </p>
</div>;
